export const initTallyFields = [
  {
    id: '',
    title: '',
    type: '',
    answer: {
      value: '',
      raw: '',
    },
  },
];

/** 定义Tally FormId */

/** enterprise 联系contact */
export enum TallyIdEnterpriseContact {
  'ja' = 'waRBBn',
  'en' = 'waRBBn',
}

/**
 * enterprise 联系contact - Email fieldId
 */
export enum TallyFieldIdEnterpriseContact {
  /** 转写评分fieldId（日) */
  'ja' = '',
  /** 转写评分fieldId（英) */
  'en' = 'c4c2662a-f125-4536-8130-b20c3a0402bc',
}
